import React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core';
import {Link} from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1)
  }
}));

const AdReceived: React.FC = () => {

  const classes = useStyles();

  return <>
    <Typography variant="h2" gutterBottom>
      Thank you
    </Typography>
    <Typography variant="subtitle1">
      Your ad has been received.
    </Typography>

    <Typography variant="subtitle1" gutterBottom>
      Detailed payment instructions have been emailed
      to you. Campus Departments will be recharged at the end of the quarter.
      Student Organizations should pay by a check made payable to UC Regents. We
      cannot accept cash or credit cards. Payment must be made before ad will
      broadcast unless we&apos;re recharging your department account at the end of the
      quarter.
    </Typography>

    <Grid container spacing={3} >
      <Grid item xs={12} sm={6}>
        <Typography variant="h3">Drop off your payment</Typography>
        <address>
          Housing, Dining &amp; Auxiliary Enterprises<br />
          1501 Residential Services<br /><br />
          Across the street from parking lot 5 between DLG and Santa Cruz.
        </address>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Typography variant="h3">Mail in your payment</Typography>
        <address>
          Housing, Dining &amp; Auxiliary Enterprises<br />
          Attn: DigiKnow<br />
          1501 Residential Services<br />
          University of California<br />
          Santa Barbara, CA 93106-6130
        </address>
      </Grid>
    </Grid>

    <div className={classes.buttons}>
      <Button
        component={Link}
        to="/"
        variant="contained"
        color="primary"
        className={classes.button}>Return to main</Button>
    </div>
  </>;
};
export default AdReceived;
